import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const useGameStore = create(
  persist(
    (set, get) => ({
      // Player Stats
      playerLevel: 1,
      playerXP: 0,
      totalScore: 0,

      // Progress
      questionProgress: {}, // { questionId: { correct: number, incorrect: number, lastAttempt: timestamp } }

      // Records
      highScores: {
        free: 0,
        random: 0,
        weak: 0,
      },
      maxCombo: 0,
      totalFeverCount: 0,

      // Settings
      settings: {
        soundEnabled: true,
        vibrationEnabled: true,
        timeLimit: true,
      },

      // Actions
      addXP: (amount) => set((state) => {
        const newXP = state.playerXP + amount
        const newLevel = Math.floor(newXP / 1000) + 1
        return {
          playerXP: newXP,
          playerLevel: newLevel,
        }
      }),

      updateScore: (score) => set((state) => ({
        totalScore: state.totalScore + score,
      })),

      updateQuestionProgress: (questionId, isCorrect) => set((state) => {
        const current = state.questionProgress[questionId] || { correct: 0, incorrect: 0 }
        return {
          questionProgress: {
            ...state.questionProgress,
            [questionId]: {
              correct: current.correct + (isCorrect ? 1 : 0),
              incorrect: current.incorrect + (isCorrect ? 0 : 1),
              lastAttempt: Date.now(),
            },
          },
        }
      }),

      updateHighScore: (mode, score) => set((state) => {
        if (score > (state.highScores[mode] || 0)) {
          return {
            highScores: {
              ...state.highScores,
              [mode]: score,
            },
          }
        }
        return state
      }),

      updateMaxCombo: (combo) => set((state) => {
        if (combo > state.maxCombo) {
          return { maxCombo: combo }
        }
        return state
      }),

      incrementFeverCount: () => set((state) => ({
        totalFeverCount: state.totalFeverCount + 1,
      })),

      updateSettings: (key, value) => set((state) => ({
        settings: {
          ...state.settings,
          [key]: value,
        },
      })),

      // 苦手問題を取得する（正答率が低い問題）
      getWeakQuestions: (allQuestions, minAttempts = 1, maxAccuracy = 70) => {
        const { questionProgress } = get()
        
        return allQuestions.filter((question) => {
          const progress = questionProgress[question.id]
          if (!progress) return false // 未挑戦の問題は含めない
          
          const totalAttempts = progress.correct + progress.incorrect
          if (totalAttempts < minAttempts) return false // 最低挑戦回数未満は除外
          
          const accuracy = (progress.correct / totalAttempts) * 100
          return accuracy < maxAccuracy // 正答率が閾値未満
        })
      },

      // 苦手問題の数を取得
      getWeakQuestionCount: (allQuestions, minAttempts = 1, maxAccuracy = 70) => {
        const { questionProgress } = get()
        
        return allQuestions.filter((question) => {
          const progress = questionProgress[question.id]
          if (!progress) return false
          
          const totalAttempts = progress.correct + progress.incorrect
          if (totalAttempts < minAttempts) return false
          
          const accuracy = (progress.correct / totalAttempts) * 100
          return accuracy < maxAccuracy
        }).length
      },

      // 問題の正答率を取得
      getQuestionAccuracy: (questionId) => {
        const { questionProgress } = get()
        const progress = questionProgress[questionId]
        if (!progress) return null
        
        const totalAttempts = progress.correct + progress.incorrect
        if (totalAttempts === 0) return null
        
        return Math.round((progress.correct / totalAttempts) * 100)
      },
    }),
    {
      name: 'genkai-vibes-storage',
    }
  )
)

export default useGameStore
